import { Box, Stack, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { Nav, NavItem } from "reactstrap";

export function Navigation({
  links = [],
  tabs = false,
  pills = true,
  vertical = "xl",
  justified = true,
  fill = false,
  card = true,
}) {
  return (
    <Box p={1}>
      <Nav {...{ tabs, pills, vertical, justified, fill, card }}>
        {links.map((link, i) => (
          <NavItem key={i}>
            <NavLink to={link.to} className="nav-link">
              <Stack spacing={1} direction="row" alignItems="center">
                {link.icon}
                <Typography>{link.label}</Typography>
              </Stack>
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    </Box>
  );
}
